import { render, staticRenderFns } from "./HomeFeedCard.vue?vue&type=template&id=95c0f302&scoped=true&"
import script from "./HomeFeedCard.vue?vue&type=script&lang=ts&"
export * from "./HomeFeedCard.vue?vue&type=script&lang=ts&"
import style0 from "./HomeFeedCard.vue?vue&type=style&index=0&id=95c0f302&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c0f302",
  null
  
)

export default component.exports